import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServiceProviderService } from 'src/app/shared/services/service-provider/service-provider.service';
import { UtilityService } from 'src/app/shared/services/Utils/utility.service';
import { MasterCollectionService } from '../../services/master-collection/master-collection.service';

@Component({
  selector: 'app-service-provider-filter',
  templateUrl: './service-provider-filter.component.html',
  styleUrls: ['./service-provider-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceProviderFilterComponent implements OnInit {
  serviceproviderList: any = [];
  selectedProvider: any = '';
  filterServiceProviders: any;
  @Input() isStaffLog: Boolean = false;
  @Input() isClear: Boolean = false;
  @Output('serviceprovider') serviceproviderEmitter = new EventEmitter();
  showDropdown: boolean = false;
  constructor(private _serviceProviderService: ServiceProviderService, private spinnerLoader: NgxSpinnerService, private utilityService: UtilityService, private dropDown: MasterCollectionService) { }

  ngOnChanges(changes: SimpleChanges) {
    const isClearChange: SimpleChange = changes.isClear; // @Input() isClear
    if (isClearChange.previousValue !== undefined) {
      if (isClearChange.currentValue !== isClearChange.previousValue) {
        this.clearFilters();
      }
    }
  }

  ngOnInit(): void {
    this.filterServiceProviders = {
      categoryName: '',
      searchText: '',
      categoryId: ''
    }
    this.getAllServiceProviders();
    this.utilityService._clearFilterObserverStaff.subscribe(async (res: any) => {
      if (res.value == 'staff') {
        this.clearFilters();
      }

    })
  }

  getAllServiceProviders() {
    this.spinnerLoader.show();
    this.dropDown.getServiveProviderDropdownList().subscribe(async (res: any) => {
      this.spinnerLoader.hide();
      this.serviceproviderList = res;
      this.serviceproviderList.sort((a, b) => a.companyName !== b.companyName ? a.companyName < b.companyName ? -1 : 1 : 0)
      this.serviceproviderList.unshift({
        companyName: 'All',
        ownerName: 'All',
        _id: ''
      })
      this.showDropdown = true;
    })
  }

  selectProvider(event) {
    if (event) {
      this.selectedProvider = event
      let obj = {
        _id: event['_id'],
        companyName: event['companyName']
      }
      this.serviceproviderEmitter.emit(obj)
    }

  }

  clearFilters() {
    // this.getAllServiceProviders();
    this.selectedProvider = ''
  }
}
